import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter as Router, Route, Routes,useLocation } from 'react-router-dom';
import { queryClient } from './lib/queryClient';
import './i18n';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage/HomePage';
import NewsPage from './pages/NewsPage/NewsPage';
import NewsArticle from "./pages/NewsPage/components/NewsArticle/NewsArticle";
import SpielePage from "./pages/SpielePage/SpielePage";
import MatchPage from "./pages/MatchPage/MatchPage.js"
import CookieInfo from "./pages/FooterPages/Cookies";
import Impressum from "./pages/FooterPages/Impressum";
//import ClubsOverviewPage from "./pages/ClubPage/ClubsOverviewPage";
//import ClubProfile from "./pages/ClubPage/ClubProfile/ClubProfile";
import TablePage from './pages/TabelePage/TablePage';
import VideosPage from './pages/VideoPage/VideosPage';
import AboutPage from './pages/AboutPage/AboutPage';
import Footer from './components/Footer';
import PageNotFoundPage from './pages/PageNotFoundPage/PageNotFoundPage'
import ErrorBoundary from './components/ErrorBoundary';
import './styles/global.css';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function RouteErrorBoundary({ children }) {
    const { pathname } = useLocation();
    return <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <div className="app">
            <Navbar />
            <main>
              <RouteErrorBoundary>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/neues" element={<NewsPage />} />
                <Route path="/neues/:newsTitle" element={<NewsArticle />} />
                <Route path="/spiele" element={<SpielePage />} />
                <Route path="/spiele/:matchId" element={<MatchPage />} />
                <Route path="/tabelle" element={<TablePage />} />
                {/*<Route path="/clubs" element={<ClubsOverviewPage />} />
                <Route path="/clubs/:clubName/*" element={<ClubProfile />} />*/}
                <Route path="/videos" element={<VideosPage />} />
                <Route path="/ueber/*" element={<AboutPage />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/cookies" element={<CookieInfo />} />
                <Route path="*" element={<PageNotFoundPage />} />
              </Routes>
              </RouteErrorBoundary>
            </main>
            <Footer />
          </div>
          <ReactQueryDevtools initialIsOpen={false}/>  
      </Router>
    </QueryClientProvider>
  );
}

export default App;
